import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import Bullets from '../../../../../components/Bullets/Bullets';
import { Col } from '../../../../../components/Col';
import CardTitle from '../../../../../components/CrudWithSteps/components/CardTitle';
import { CustomButton } from '../../../../../components/CustomButton';
import { CustomNumberField } from '../../../../../components/CustomNumberField';
import { CustomTextField } from '../../../../../components/CustomTextField';
import GenericCardScreen from '../../../../../components/GenericCardScreen/GenericCardScreen';
import { HelpButton } from '../../../../../components/HelpButton';
import ArrowBackIcon from '../../../../../components/Icons/ArrowBackIcon';
import ArrowDownwardIcon from '../../../../../components/Icons/ArrowDownwardIcon';
import { DateMaskedInput } from '../../../../../components/MaskedInputs';
import NewAutoCompleteField from '../../../../../components/NewAutoCompleteField/NewAutoCompleteField';
import { Row } from '../../../../../components/Row';
import { CONTRATO_EDIT_ETAPA_VALIDACAO } from '../../../../../library/ContratoEditEtapas';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_CONTRATO,
  CONTRATO_VERSAO_DISTRATO,
} from '../../../../../library/ContratoVersoes';
import {
  contratoAditivoEditRoute,
  contratoDistratoEditRoute,
  contratoEditRoute,
} from '../../../../../library/Routes';
import {
  changeContratoEntePublicoEditingValue,
  contratoEntePublicoRegisterPreEtapa,
} from '../../../../../store/modules/ContratosEntePublicoActions';
import {
  loadCidadesByEstadoId,
  loadEstados,
} from '../../../../../store/modules/LogradouroActions';
import { getContratoTipoByRouteParams } from '../../../../../utils/ContratoUtils';
import { diferenceMonths } from '../../../../../utils/DateUtils';
import { getPropsToLabel } from '../../../../../utils/HelpButtonUtils';
import { getElementID } from '../../../../../utils/HTMLUtils';
import {
  allIsTrue,
  dateIsValid,
  estadoRequiredIsValid,
  integerIsValid,
  maskedValueRequiredIsValid,
  requiredIsValid,
  strCidadeRequiredIsValid,
} from '../../../../../utils/ValidationUtils';
import genericCardStyles from './../../../../../components/GenericCard/GenericCard.scss';
import styles from './DadosContrato.scss';
import GenericDados from './GenericDados';

const rootClassName = styles.rootClassName;
const rootElementId = 'contrato-dados-contrato-ente-publico';

const INITIAL_STATE = {
  sending: false,

  idEstadoChanged: false,
  nomCidadeChanged: false,
  dataInicioChanged: false,
  totalMesesChanged: false,
  dataFimChanged: false,
  reembolsoChanged: false,
};

class DadosContrato extends GenericDados {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };
  }

  getActions = () => {
    return (
      <Row className={genericCardStyles.rootClassName + '-card-actions-row'}>
        <Col
          cols={[12, 12, 6, 6, 6]}
          className={genericCardStyles.rootClassName + '-card-actions-left'}
        >
          <CustomButton
            label={this.props.languageValues.anterior}
            theme='pufvYellow'
            onClick={this.toPrevContent}
            leftIcon={<ArrowBackIcon />}
          />
        </Col>
        <Col
          cols={[12, 12, 6, 6, 6]}
          className={genericCardStyles.rootClassName + '-card-actions-right'}
        >
          <CustomButton
            label={this.props.languageValues.concluirEAvancarEtapa}
            theme='pufvYellow'
            onClick={() => {
              if (this.formIsValid()) {
                this.toSubmit(
                  2,
                  this.props.contratosEntePublico.contratoEditing,
                  this.submitCallbackStart,
                  this.submitCallbackSuccess,
                  this.submitCallbackError
                );
              }
            }}
            rightIcon={<ArrowDownwardIcon />}
            disabled={this.submitButtonIsDisabled()}
          />
        </Col>
      </Row>
    );
  };

  submitButtonIsDisabled = () => {
    if (this.hasPermissions()) {
      return this.props.loading || this.state.sending || !this.formIsValid();
    }
    return true;
  };

  fieldDisabled() {
    if (!this.hasPermissions()) {
      return true;
    }
    const editing = this.editing();
    if (editing) {
      if (!this.props.auth.userPermissions.contratos.entePublico.edit) {
        return true;
      }
    }
    return this.state.sending || this.props.loading;
  }

  reset() {
    this.setState(INITIAL_STATE);
  }

  UNSAFE_componentWillMount() {
    this.loadEstados();
  }

  componentWillUnmount() {
    this.reset();
  }

  getUFByIdEstado = (idEstado) => {
    const estados = this.props.logradouro.estados.filter((estado) => {
      if (estado.id === idEstado) {
        return true;
      }
      return false;
    });
    if (estados && estados.length > 0) {
      return estados[0].sigla;
    }
    return '';
  };

  loadEstados = () => {
    this.props.loadEstados(
      () => {
        if (this.props.contratosEntePublico.contratoEditing.idEstado) {
          this.loadCidades(
            this.props.contratosEntePublico.contratoEditing.idEstado
          );
        }
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.errorLoadEstados,
          options: {
            variant: 'error',
          },
        });
      }
    );
  };

  getCidades = (uf) => {
    if (!uf || uf.length === 0) {
      return [];
    }
    return this.props.logradouro.cidades[uf.toLowerCase()] || [];
  };

  loadCidades = (idEstado) => {
    const uf = this.getUFByIdEstado(idEstado);
    if (uf && this.getCidades(uf).length === 0) {
      this.props.loadCidadesByEstadoId(idEstado, uf);
    }
  };

  dataInicioIsValid = () => {
    const value = this.props.contratosEntePublico.contratoEditing.dataInicio;
    const required = maskedValueRequiredIsValid(
      value,
      this.props.languageValues.validations.dataInicio.required
    );
    const validation = dateIsValid(
      value,
      this.props.languageValues.validations.dataInicio.validation
    );
    if (!required.status) {
      return required;
    }
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };

  totalMesesIsValid = () => {
    const value = this.props.contratosEntePublico.contratoEditing.totalMeses;
    const required = requiredIsValid(
      value,
      this.props.languageValues.validations.totalMeses.required
    );
    const validation = integerIsValid(
      value,
      true,
      this.props.languageValues.validations.totalMeses.validation
    );
    if (!required.status) {
      return required;
    }
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };

  dataFimIsValid = () => {
    const value = this.props.contratosEntePublico.contratoEditing.dataFim;
    const required = maskedValueRequiredIsValid(
      value,
      this.props.languageValues.validations.dataFim.required
    );
    const validation = dateIsValid(
      value,
      this.props.languageValues.validations.dataFim.validation
    );
    if (!required.status) {
      return required;
    }
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };

  dataDistratoIsValid = () => {
    const value = this.props.contratosEntePublico.contratoEditing.dataDistrato;
    const required = maskedValueRequiredIsValid(
      value,
      this.props.languageValues.validations.dataDistrato.required
    );
    const validation = dateIsValid(
      value,
      this.props.languageValues.validations.dataDistrato.validation
    );
    if (!required.status) {
      return required;
    }
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };

  idEstadoValueIsValid = () => {
    const required = estadoRequiredIsValid(
      this.props.contratosEntePublico.contratoEditing.idEstado,
      this.props.languageValues.validations.estado.required
    );
    if (!required.status) {
      return required;
    }
    return {
      status: true,
    };
  };

  estadoFieldIsDisabled = () => {
    return this.props.versaoContrato !== CONTRATO_VERSAO_CONTRATO ||
      this.fieldDisabled() ||
      this.props.logradouro.loadingAllEstadosByCoops ||
      !this.codCoopValueIsValid().status
      ? true
      : false;
  };

  cidadeFieldIsDisabled = () => {
    return this.props.versaoContrato !== CONTRATO_VERSAO_CONTRATO ||
      this.fieldDisabled() ||
      this.props.logradouro.loadingCidades ||
      this.props.contratosEntePublico.contratoEditing.idEstado < 1
      ? true
      : false;
  };

  nomCidadeValueIsValid = () => {
    const required = strCidadeRequiredIsValid(
      this.props.contratosEntePublico.contratoEditing.nomCidade,
      this.props.languageValues.validations.cidade.required
    );
    if (!required.status) {
      return required;
    }
    return {
      status: true,
    };
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      (newProps.loading !== this.props.loading && !newProps.loading) ||
      (!newProps.loading &&
        newProps.contratosEntePublico.contratoEditing.idEstado !==
          this.props.contratosEntePublico.contratoEditing.idEstado)
    ) {
      if (newProps.contratosEntePublico.contratoEditing.idEstado) {
        this.loadCidades(
          newProps.contratosEntePublico.contratoEditing.idEstado
        );
      }
    }
  }

  onDataInicioChanged = (value) => {
    let months = diferenceMonths(
      value,
      this.props.contratosEntePublico.contratoEditing.dataFim
    );
    this.props.changeContratoEntePublicoEditingValue('totalMeses', months);
  };

  onDataFimChanged = (value) => {
    let months = diferenceMonths(
      this.props.contratosEntePublico.contratoEditing.dataInicio,
      value
    );
    this.props.changeContratoEntePublicoEditingValue('totalMeses', months);
  };

  idEstadoValueChanged = () => {
    this.setValue({
      target: {
        name: 'nomCidade',
        value: '',
      },
    });
  };

  formIsValid() {
    const arr = [
      this.idEstadoValueIsValid().status,
      this.nomCidadeValueIsValid().status,
      this.props.contratosEntePublico.contratoEditing.versaoContrato !==
      CONTRATO_VERSAO_DISTRATO
        ? this.dataInicioIsValid().status
        : true,
      this.props.contratosEntePublico.contratoEditing.versaoContrato !==
      CONTRATO_VERSAO_DISTRATO
        ? this.totalMesesIsValid().status
        : true,
      this.props.contratosEntePublico.contratoEditing.versaoContrato !==
      CONTRATO_VERSAO_DISTRATO
        ? this.dataFimIsValid().status
        : true,
      this.props.contratosEntePublico.contratoEditing.versaoContrato ===
      CONTRATO_VERSAO_DISTRATO
        ? this.dataDistratoIsValid().status
        : true,
    ];
    return allIsTrue(arr);
  }

  getGenericCardScreenProps = () => {
    return {
      GenericCardProps: {
        className: rootClassName,
        title: (
          <CardTitle onClick={this.openStepsMenu}>
            {this.props.languageValues.cadastroContratoDadosContrato}
          </CardTitle>
        ),
        actions: this.getActions(),
        bottomContent: (
          <Bullets
            total={this.props.totalBullets}
            selectedIndex={this.props.bulletsIndex}
          />
        ),
        CardContentProps: {
          className: rootClassName + '-card-content',
        },
        sending: this.state.sending || this.props.loading,
      },
    };
  };

  submitCallbackStart = () => {
    this.setState({
      sending: true,
    });
  };

  submitCallbackSuccess = () => {
    this.setState({
      sending: false,
    });
    const idContrato =
      this.props.contratosEntePublico.contratoEditing.idContrato;
    const idAditivo = this.props.contratosEntePublico.contratoEditing.idAditivo;
    const idDistrato =
      this.props.contratosEntePublico.contratoEditing.idDistrato;
    const etapa = CONTRATO_EDIT_ETAPA_VALIDACAO;
    switch (this.props.contratosEntePublico.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        this.props.history.push(
          contratoAditivoEditRoute.getURLWithParams(
            getContratoTipoByRouteParams(this.props.match.params),
            idContrato,
            idAditivo,
            etapa
          )
        );
        break;
      case CONTRATO_VERSAO_DISTRATO:
        this.props.history.push(
          contratoDistratoEditRoute.getURLWithParams(
            getContratoTipoByRouteParams(this.props.match.params),
            idContrato,
            idDistrato,
            etapa
          )
        );
        break;
      default:
        this.props.history.push(
          contratoEditRoute.getURLWithParams(
            getContratoTipoByRouteParams(this.props.match.params),
            idContrato,
            etapa
          )
        );
        break;
    }
  };

  submitCallbackError = () => {
    this.setState({
      sending: false,
    });
  };

  render() {
    return (
      <GenericCardScreen {...this.getGenericCardScreenProps()}>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            if (this.formIsValid()) {
              this.toSubmit(
                2,
                this.props.contratosEntePublico.contratoEditing,
                this.submitCallbackStart,
                this.submitCallbackSuccess,
                this.submitCallbackError
              );
            }
          }}
        >
          <>
            <button
              type='submit'
              className='hidden-button'
              disabled={this.submitButtonIsDisabled()}
            ></button>
            <Row>
              <Col cols={[12, 6, 6, 6, 6]}>
                <NewAutoCompleteField
                  id={getElementID(rootElementId, 'estado')}
                  label={
                    <>
                      {this.props.languageValues.estado}
                      <HelpButton
                        text={this.props.languageValues.estadoEntePublicoHint}
                        {...getPropsToLabel()}
                      />
                    </>
                  }
                  placeholder={
                    this.props.logradouro.loadingAllEstadosByCoops
                      ? this.props.languageValues.loadingEstados
                      : ''
                  }
                  options={this.props.logradouro.estados.map((item) => {
                    return {
                      label: item.nome,
                      value: item.id,
                      sigla: item.sigla,
                    };
                  })}
                  value={
                    this.props.contratosEntePublico.contratoEditing.idEstado
                  }
                  onChange={(value) => {
                    const currValue =
                      value && value.value > -1 ? value.value : -1;
                    this.setValue({
                      target: {
                        name: 'idEstado',
                        value: currValue,
                      },
                    });
                  }}
                  loading={this.props.logradouro.loadingAllEstadosByCoops}
                  loadingMessage={this.props.languageValues.loadingEstados}
                  disabled={
                    this.estadoFieldIsDisabled() ||
                    this.fieldDisabled() ||
                    !this.codCoopValueIsValid().status
                  }
                  error={
                    !this.estadoFieldIsDisabled() &&
                    this.state.idEstadoChanged &&
                    !this.idEstadoValueIsValid().status
                  }
                  helperText={
                    !this.estadoFieldIsDisabled() &&
                    this.state.idEstadoChanged &&
                    !this.idEstadoValueIsValid().status
                      ? this.idEstadoValueIsValid().error
                      : ''
                  }
                />
              </Col>
              <Col cols={[12, 6, 6, 6, 6]}>
                <NewAutoCompleteField
                  id={getElementID(rootElementId, 'cidade')}
                  label={
                    <>
                      {this.props.languageValues.cidade}
                      <HelpButton
                        text={this.props.languageValues.cidadeEntePublicoHint}
                        {...getPropsToLabel()}
                      />
                    </>
                  }
                  placeholder={
                    this.props.logradouro.loadingCidades
                      ? this.props.languageValues.loadingCidades
                      : ''
                  }
                  options={this.getCidades(
                    this.getUFByIdEstado(
                      this.props.contratosEntePublico.contratoEditing.idEstado
                    )
                  ).map((item) => {
                    return {
                      label: item.nome,
                      value: item.nome,
                    };
                  })}
                  value={
                    this.props.contratosEntePublico.contratoEditing.nomCidade
                  }
                  onChange={(value) => {
                    const currValue =
                      value && value.value > '' ? value.value : '';
                    this.setValue({
                      target: {
                        name: 'nomCidade',
                        value: currValue,
                      },
                    });
                  }}
                  loading={this.props.logradouro.loadingCidades}
                  loadingMessage={this.props.languageValues.loadingCidades}
                  disabled={this.cidadeFieldIsDisabled()}
                  helperText={
                    !this.cidadeFieldIsDisabled() &&
                    this.state.nomCidadeChanged &&
                    !this.nomCidadeValueIsValid().status
                      ? this.nomCidadeValueIsValid().error
                      : ''
                  }
                  error={
                    !this.cidadeFieldIsDisabled() &&
                    this.state.nomCidadeChanged &&
                    !this.nomCidadeValueIsValid().status
                  }
                />
              </Col>
            </Row>
          </>
          {this.props.contratosEntePublico.contratoEditing.versaoContrato !==
          CONTRATO_VERSAO_DISTRATO ? (
            <>
              <Row>
                <Col cols={[12, 12, 6, 6, 6]}>
                  <CustomTextField
                    id={getElementID(rootElementId, 'data-inicio')}
                    label={this.props.languageValues.cadastroContratoDataInicio}
                    name='dataInicio'
                    value={
                      this.props.contratosEntePublico.contratoEditing.dataInicio
                    }
                    onChange={(event) => {
                      const value = event.target.value.trim();
                      if (value.length === 10) {
                        this.setValue(event, () =>
                          this.onDataInicioChanged(value)
                        );
                      }
                    }}
                    InputProps={{
                      inputComponent: DateMaskedInput,
                    }}
                    helperText={
                      this.state.dataInicioChanged &&
                      !this.dataInicioIsValid().status
                        ? this.dataInicioIsValid().error
                        : ''
                    }
                    error={
                      this.state.dataInicioChanged &&
                      !this.dataInicioIsValid().status
                    }
                    disabled={this.fieldDisabled()}
                  />
                </Col>
                <Col cols={[12, 12, 6, 6, 6]}>
                  <CustomNumberField
                    id={getElementID(rootElementId, 'total-meses')}
                    label={this.props.languageValues.cadastroContratoTotalMeses}
                    name='totalMeses'
                    value={Number(
                      this.props.contratosEntePublico.contratoEditing.totalMeses
                    ).toString()}
                    onChange={(event) => {
                      this.setValue(event, this.onTotalMesesChanged);
                    }}
                    onlyInteger={true}
                    onlyPositive={true}
                    error={
                      this.state.totalMesesChanged &&
                      !this.totalMesesIsValid().status
                    }
                    helperText={
                      this.state.totalMesesChanged &&
                      !this.totalMesesIsValid().status
                        ? this.totalMesesIsValid().error
                        : ''
                    }
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col cols={[12, 12, 6, 6, 6]}>
                  <CustomTextField
                    id={getElementID(rootElementId, 'data-fim')}
                    label={this.props.languageValues.cadastroContratoDataFim}
                    name='dataFim'
                    value={
                      this.props.contratosEntePublico.contratoEditing.dataFim
                    }
                    onChange={(event) => {
                      const value = event.target.value.trim();
                      if (value.length === 10) {
                        this.setValue(event, () =>
                          this.onDataFimChanged(value)
                        );
                      }
                    }}
                    InputProps={{
                      inputComponent: DateMaskedInput,
                    }}
                    helperText={
                      this.state.dataFimChanged && !this.dataFimIsValid().status
                        ? this.dataFimIsValid().error
                        : ''
                    }
                    error={
                      this.state.dataFimChanged && !this.dataFimIsValid().status
                    }
                    disabled={this.fieldDisabled()}
                  />
                </Col>
              </Row>
            </>
          ) : (
            <Row>
              <Col cols={[12, 12, 6, 6, 6]}>
                <CustomTextField
                  id={getElementID(rootElementId, 'data-distrato')}
                  label={this.props.languageValues.cadastroContratoDataDistrato}
                  name='dataDistrato'
                  value={
                    this.props.contratosEntePublico.contratoEditing.dataDistrato
                  }
                  onChange={this.setValue}
                  InputProps={{
                    inputComponent: DateMaskedInput,
                  }}
                  disabled={this.fieldDisabled()}
                />
              </Col>
            </Row>
          )}
        </form>
      </GenericCardScreen>
    );
  }
}

DadosContrato.propTypes = {
  editing: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  logradouro: state.logradouro,
  contratosEntePublico: state.contratosEntePublico,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeContratoEntePublicoEditingValue,
      contratoEntePublicoRegisterPreEtapa,
      loadEstados,
      loadCidadesByEstadoId,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DadosContrato));
